// 京东金融首页openapp链接地址
export const JDJR_OPENAPP_LINK_HOME =
  'openjdjrapp://com.jd.jrapp/main/homepage?jrproductid=channel&jrlogin=false&jrcontainer=native'

// 京东商城首页openapp链接地址
export const JD_OPENAPP_LINK_HOME =
  'openapp.jdmobile://virtual?params={"category":"jump","des":"HomePage"}'

// JD App Webview 注册码（https://opendoc.jd.com/jd-jssdk/v4/jd-webview.html#%E6%B3%A8%E5%86%8Cjsbridge-code-%E2%80%A2-registercode）
export const JD_WEBVIEW_CODE = '983dfdad-1a15-40eb-990d-b88ac7837100'
